module.exports = __webpack_public_path__ + "static/img/Map.f14e192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/Map.jpg
// module id = FjRa
// module chunks = 4